import { render, staticRenderFns } from "./MarangoniEffectViz.vue?vue&type=template&id=48657dbd&scoped=true"
import script from "./MarangoniEffectViz.vue?vue&type=script&lang=js"
export * from "./MarangoniEffectViz.vue?vue&type=script&lang=js"
import style0 from "./MarangoniEffectViz.vue?vue&type=style&index=0&id=48657dbd&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48657dbd",
  null
  
)

export default component.exports